import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import styled from 'styled-components';
import DataGridPreviewHeader from './DataGridPreviewHeader';
import clsx from 'clsx';
import { useTheme } from '@material-ui/styles';

const openClass = 'dataGridPreview-open';

const DataGridPreviewContainer = styled.div`
  position: relative;
  width: 0;
  flex-shrink: 0;
  transition: ${props =>
    props.theme.transitions.create('width', {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.leavingScreen,
    })};

  &.${openClass} {
    width: ${props => props.drawerWidth}px;
    transition: ${props =>
      props.theme.transitions.create('width', {
        easing: props.theme.transitions.easing.easeOut,
        duration: props.theme.transitions.duration.enteringScreen,
      })};
  }
`;

const DataGridPreviewDrawer = styled(({ drawerWidth, ...otherProps }) => (
  <Drawer {...otherProps} />
))`
  && {
    .MuiDrawer-paper {
      width: calc(100% - 56px);
      max-width: ${props => props.drawerWidth}px;
      overflow-y: initial;
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  min-height: 100%;
  padding: ${props => props.theme.spacing()}px ${props => props.theme.spacing(2)}px
    ${props => props.theme.spacing(2)}px;
`;

const DataGridPreview = ({
  children,
  title,
  menu,
  open,
  onClose,
  drawerWidth: drawerWidthProp,
}) => {
  const { spacing } = useTheme();
  let forwardedDrawerWidth = drawerWidthProp;

  if (forwardedDrawerWidth === null) {
    forwardedDrawerWidth = spacing(50);
  }

  return (
    <>
      <Hidden lgUp implementation="js">
        <DataGridPreviewDrawer
          variant="temporary"
          open={open}
          anchor="right"
          drawerWidth={forwardedDrawerWidth}
          onClose={onClose}
        >
          <ContentContainer>
            {(title || menu.length > 0) && (
              <DataGridPreviewHeader title={title} menu={menu} onClose={onClose} />
            )}
            {children}
          </ContentContainer>
        </DataGridPreviewDrawer>
      </Hidden>
      <Hidden mdDown implementation="js">
        <DataGridPreviewContainer
          className={clsx({ 'dataGridPreview-open': open })}
          drawerWidth={forwardedDrawerWidth}
        >
          <DataGridPreviewDrawer
            variant="persistent"
            open={open}
            anchor="right"
            drawerWidth={forwardedDrawerWidth}
          >
            <ContentContainer>
              {(title || menu.length > 0) && (
                <DataGridPreviewHeader title={title} menu={menu} onClose={onClose} />
              )}
              {children}
            </ContentContainer>
          </DataGridPreviewDrawer>
        </DataGridPreviewContainer>
      </Hidden>
    </>
  );
};

DataGridPreview.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  menu: PropTypes.array,
  open: PropTypes.bool,
  drawerWidth: PropTypes.number,
  onClose: PropTypes.func,
};

DataGridPreview.defaultProps = {
  children: undefined,
  title: undefined,
  menu: [],
  open: false,
  drawerWidth: null,
  onClose: undefined,
};

export default DataGridPreview;
